import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { ResponsePaginated } from 'crono-fe-common/types/response';
import { List, ListType } from 'crono-fe-common/types/list';

export interface IListSearchParams {
  limit?: number;
  offset?: number;
  name?: string;
  type?: ListType;
  sortType?:
    | 'Creation'
    | 'CreationDesc'
    | 'Name'
    | 'NameDesc'
    | 'OpenLists'
    | 'IncludedFirst';
  accountId?: string;
  prospectId?: string;
  //Only the lists the current user owns
  owned?: boolean;
}

export default function useSearchLists(
  listParams: IListSearchParams,
  enabled = true,
) {
  const searchLists = async () => {
    const request: Request = {
      url: `${ENDPOINTS.list.search}`,
      config: {
        method: 'post',
        data: { data: listParams },
      },
    };

    return client(request);
  };

  const { data, ...rest } = useQuery<ResponsePaginated<List[]>, CronoError>(
    [ENDPOINTS.list.search, listParams],
    searchLists,
    {
      staleTime: 5 * 60 * 1000,
      enabled,
    },
  );

  return { data, ...rest };
}
